import usePropsContext from '/druid/internal/usePropsContext';

export default function useDir() {
  const { dir } = usePropsContext();

  return [dir];
}
